@app.service 'ssoUrlService', ($resource, CookieService) ->

  AuthUrlPathConfig =
    us: 'en-us/auth'
    ca: 'en-ca/auth'
    au: 'en-au/auth'
    fr: 'en-fr/auth'
    de: 'en-de/auth'
    es: 'en-es/auth'
    gb: 'en-uk/auth'

  defaultLocation = 'us'

  @getSsoUrl = ->
    userLocation = defaultLocation

    geoCookie = CookieService.get('cs_geo')
    if geoCookie
      try
        csGeo = JSON.parse(geoCookie)
        userLocation = _.get(csGeo, 'country', defaultLocation).toLowerCase()
      catch error
        console.error 'Error parsing cs_geo cookie:', error

    locationPath = AuthUrlPathConfig[userLocation] || AuthUrlPathConfig[defaultLocation]
    return "/#{locationPath}"

  this
